import { useState } from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import * as Sc from './InputText.style'
import Tooltip from 'components/Tooltip'
import { TYPES_DATA_USER } from 'utils/constants'


const InputText = ({
  disabled,
  id,
  isValid,
  label,
  maxLength,
  message,
  name,
  onChange,
  placeholder,
  showLoader,
  tooltip,
  type,
  value,
}) => {
  const { t } = useTranslation()
  const [newType, setNewType] = useState(type)
  const [showPassword, setShowPassword] = useState(false)

  const handleChange = () => {
    const currentType =
      newType === TYPES_DATA_USER.PASSWORD ? 'text' : TYPES_DATA_USER.PASSWORD
    setNewType(currentType)
    setShowPassword(!showPassword)
  }

  return (
    <Sc.Container>
      <Sc.Label htmlFor={id} isValid={isValid}>
        {label}
        <input
          autoComplete='off'
          data-testid={id}
          disabled={disabled}
          id={id}
          maxLength={maxLength}
          onChange={onChange}
          placeholder={placeholder}
          type={newType}
          value={value}
        />
        <Sc.Wrapper>
          {showLoader && <Sc.Loader />}
          {tooltip && (
            <div>
              <Tooltip text={tooltip.text}>{tooltip.icon}</Tooltip>
            </div>
          )}
        </Sc.Wrapper>
        {message && <Sc.Message>{message}</Sc.Message>}
      </Sc.Label>
      {name === TYPES_DATA_USER.PASSWORD && !showLoader && (
        <Sc.CheckBox htmlFor={`showText${id}`} isValid={isValid}>
          <input
            checked={showPassword}
            disabled={disabled}
            id={`showText${id}`}
            onChange={handleChange}
            type='checkbox'
          />
          <span>{t('Mostrar')}</span>
        </Sc.CheckBox>
      )}
    </Sc.Container>
  )
}

InputText.defaultProps = {
  disabled: false,
  isValid: null,
  label: '',
  maxLength: null,
  message: '',
  name: '',
  placeholder: '',
  showLoader: false,
  tooltip: null,
  type: 'text',
  value: '',
}

InputText.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isValid: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  message: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  showLoader: PropTypes.bool,
  tooltip: PropTypes.shape({
    icon: PropTypes.node,
    text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }),
  type: PropTypes.string,
  value: PropTypes.string,
}

export default InputText
